import PropTypes from "prop-types";
import React, {useEffect, useState} from 'react';
import {API_URL, TOKEN} from "../../../../variables/constants";
import {frenchDateOnly, frenchDatews} from "../../../../variables/functions";
import {Image, QRCode} from "antd";

const AttestationDigitale = React.forwardRef((props, ref) => {
    const [logoPreviewUrl, setLogoPreviewUrl] = useState(null);
    const getKey = (datetime) => {
        if (!datetime) return '';

        const date = new Date(datetime);
        const timestamp = date.getTime().toString().substring(2, 13);
        const codePart = props?.engin?.codeId?.substring(2, 5) || 'XX';

        return codePart + timestamp;
    };
    const getCurrentDatetime = () => {
        return new Date().toISOString();
    };


    useEffect(() => {
        if (props?.contrat?.organisme?.logo) {
            fetch(
                `${API_URL}/api/organisme/logo/${props?.contrat?.organisme?.logo.split("/")[1]}`,
                {
                    headers: {
                        Authorization: `Bearer ${TOKEN}`,
                        "Content-Type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Methods":
                            "GET, PUT, POST, DELETE, OPTIONS",
                        "Access-Control-Allow-Headers":
                            "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
                    },
                }
            )
                .then(async (response) => {

                    // convert byte to file
                    const imageBytes = await response.arrayBuffer();
                    const blob = new Blob([imageBytes], {type: "image/png"});
                    const imageUrl = URL.createObjectURL(blob);
                    setLogoPreviewUrl(imageUrl);
                    const file = new File([blob], props?.contrat?.organisme?.logo.split("//")[2], {
                        type: "image/png",
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        }

    }, []);

    return (
        <div className="container">
            <div
                ref={ref}
                className=""
                style={{
                    height: "500px",
                    width: "270px",
                    position: "absolute",
                    fontFamily: "Poppins",
                    color: props.tint
                }}
            >
                <Image
                    src={props.background}
                    alt="Background"
                    style={{
                        height: "100%",
                        width: "100%",
                        objectFit: "contain",
                    }}
                    preview={false}
                />

                <div className="row">
                    <div style={{
                        position: 'absolute',
                        marginTop: '-488px',
                        marginLeft: '233px',
                        width: '55px'
                    }}>
                        <Image style={{
                            width: '100%',
                            backgroundPosition: 'center',
                            borderRadius: '5px'
                        }} src={logoPreviewUrl}
                               preview={false}
                        />
                    </div>
                    <div className="col" style={{position: 'relative'}}>
                        <h6
                            className="text-left"
                            style={{
                                position: 'absolute',
                                marginLeft: "24px",
                                marginTop: "-335px",
                                fontSize: '12px',
                                color: props.tint
                            }}
                        >
                            <b>{props.engin?.immatriculation || ""}</b>
                        </h6>
                        <h6
                            className="text-left"
                            style={{
                                position: 'absolute',
                                marginLeft: "180px",
                                marginTop: "-334px",
                                fontSize: "6px",
                                color: 'black'
                            }}
                        >
                            <b>{props?.engin?.numeroAttestationDigitale}</b>
                        </h6>
                        <h6
                            className="text-left"
                            style={{
                                position: 'absolute',
                                marginLeft: "53px",
                                marginTop: "-313px",
                                marginBottom: '3px',
                                fontWeight: '550',
                                color: '#145083',
                                fontSize: '9px'
                            }}
                        >
                            {props.engin?.genre || ""}
                        </h6>
                        <h6
                            className="text-left"
                            style={{position: 'absolute', marginLeft: "175px", marginTop: "-320px", fontSize: "9px"}}
                        >
                            <QRCode size={80} value={props?.engin.force} color={props?.tint} errorLevel={'H'}
                            />
                        </h6>
                        <h6
                            className="text-left"
                            style={{
                                position: 'absolute',
                                marginLeft: "61px",
                                marginTop: "-301px",
                                fontWeight: '550',
                                color: '#145083',
                                fontSize: '9px'
                            }}
                        >
                            {props.engin?.marque || ""}
                        </h6>
                        <h6
                            className="text-left"
                            style={{
                                position: 'absolute',
                                marginLeft: "60px",
                                marginTop: "-291px",
                                fontWeight: '550',
                                color: '#145083',
                                fontSize: '9px'
                            }}
                        >
                            {props.engin?.type || ""}
                        </h6>
                        <h6
                            className="text-left"
                            style={{
                                position: 'absolute',
                                marginLeft: "110px",
                                marginTop: "-280px",
                                fontWeight: '550',
                                color: '#145083',
                                fontSize: '9px'
                            }}
                        >
                            {props.engin?.usage || ""}
                        </h6>
                        <h6
                            className="text-left"
                            style={{
                                position: 'absolute',
                                marginLeft: "74px",
                                marginTop: "-269px",
                                fontWeight: '550',
                                color: '#145083',
                                fontSize: '9px',

                            }}
                        >
                            {props.engin?.numeroChassis || ""}
                        </h6>
                        <div style={{
                            position: 'absolute',
                            marginLeft: "6px",
                            marginTop: "-236px",
                            color: "white",
                            textAlign: 'left',
                            width: '259px',
                            height: '64px',
                            borderRadius: '12px',
                            display: 'flex',
                            flexDirection: 'row',
                            // justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: 5,
                        }}>
                            <div
                                style={{
                                    position: 'relative',
                                    marginLeft: '9px',
                                    marginTop: '2px',
                                    fontFamily: 'poppins',
                                    fontWeight: 'normal',
                                    width: '50%',
                                    height: '43px',
                                }}
                            >
                                <Image
                                    src={logoPreviewUrl}
                                    style={{
                                        width: '60px',
                                        height: '43px',
                                        objectFit: 'cover',
                                        backgroundPosition: 'center',
                                        borderRadius: '10px'
                                    }}
                                    preview={false}
                                />
                            </div>
                            <div style={{
                                paddingRight: 5,
                                justifyContent: 'center',
                                alignItems: 'flex-start',
                                textAlign: 'left',
                                display: 'flex',
                                flexDirection: 'column',
                                height: '100%',
                                position: 'relative',
                                fontWeight: 'normal',
                                fontFamily: 'Poppins',
                                fontSize: '3px',
                                width: '100%',
                                marginLeft: '10px',
                            }}>
                                <p
                                    style={{
                                        position: 'relative',
                                        color: "white",
                                        textAlign: 'left',
                                        margin: 0,
                                        padding: 0,
                                        fontSize: '7px'
                                    }}
                                >
                                    {props.contrat?.organisme?.raisonSociale || ""}
                                </p>
                                <p
                                    style={{
                                        position: 'relative',
                                        color: "white",
                                        textAlign: 'left',
                                        margin: 0,
                                        padding: 0,
                                        fontSize: '5px'
                                    }}
                                >
                                    {props.contrat?.organisme?.siegeSocial || ""}
                                </p>
                                <p
                                    style={{
                                        position: 'relative',
                                        color: "white",
                                        textAlign: 'left',
                                        margin: 0,
                                        padding: 0,
                                        fontSize: '5px'
                                    }}
                                >
                                    {props.contrat?.organisme?.email || ""}
                                </p>
                                <p
                                    style={{
                                        position: 'relative',
                                        color: "white",
                                        textAlign: 'left',
                                        margin: 0,
                                        padding: 0,
                                        fontSize: '5px'
                                    }}
                                >
                                    Agence: {props.contrat?.producteur?.agence?.nom || ""}
                                </p>
                                {props.contrat?.producteur?.agence?.ville !== props.contrat?.organisme?.siegeSocial && (
                                    <>
                                        <p
                                            style={{
                                                position: 'relative',
                                                color: "white",
                                                textAlign: 'left',
                                                margin: 0,
                                                padding: 0,
                                                fontSize: '10px'
                                            }}
                                        >
                                            &nbsp;&nbsp;&nbsp;  {props.contrat?.producteur?.agence?.ville || ""}
                                        </p>
                                    </>
                                )}
                            </div>


                        </div>
                        <p
                            className="text-left"
                            style={{
                                position: 'absolute',
                                marginLeft: "18px",
                                marginTop: "-154px",
                                color: "white",
                                fontWeight: 500,
                                fontSize: '9px'
                            }}
                        >
                            {props.contrat?.souscripteur?.nom}{" "}
                            {props.contrat?.souscripteur?.typePersonne === 'PHYSIQUE' && props.contrat?.souscripteur?.prenom || ""}
                        </p>
                        <p
                            className="text-left"
                            style={{
                                position: 'absolute',
                                marginLeft: "109px",
                                marginTop: "-154px",
                                color: "white",
                                fontWeight: 500,
                                fontSize: '9px'
                            }}
                        >
                            {props.contrat?.souscripteur?.contact?.[0] || " "}
                        </p>
                        <div style={{position: 'absolute', marginTop: '-202px', marginLeft: '145px'}}>
                            <svg width="150" height="120"
                                 style={{position: 'absolute', fontWeight: 550}}>
                                <defs>
                                    <path id="splinePath" d="M55,37 C65,54 62,114 117,119" fill="none"
                                    />
                                </defs>
                                <use href="#splinePath"/>
                                <text fill={'#0a0a0a'} fontSize="14" fontWeight="medium" fontFamily={'Poppins'}>
                                    <textPath href="#splinePath">
                                        {getKey(props?.contrat?.createdAt)}
                                    </textPath>
                                </text>
                            </svg>
                        </div>

                        <p
                            className="text-left"
                            style={{
                                position: 'absolute',
                                marginLeft: "19px",
                                marginTop: "-129px",
                                color: "white",
                                fontWeight: 500,
                                fontSize: '9px'
                            }}
                        >
                            {frenchDateOnly(props?.contrat?.dateEffet)}
                        </p>
                        <p
                            className="text-left"
                            style={{
                                position: 'absolute',
                                marginLeft: "110px",
                                marginTop: "-129px",
                                color: "white",
                                fontWeight: 500,
                                fontSize: '9px'
                            }}
                        >
                            {frenchDateOnly(props.contrat?.dateEcheance)}
                        </p>
                        <p
                            className="text-left"
                            style={{
                                position: 'absolute',
                                marginLeft: "19px",
                                marginTop: "-104px",
                                color: "white",
                                fontWeight: 500,
                                fontSize: '9px'
                            }}
                        >
                            {frenchDatews(props.engin?.dateImpression)}
                        </p>
                        <p
                            className="text-left"
                            style={{
                                position: 'absolute',
                                marginLeft: "110px",
                                marginTop: "-104px",
                                color: "white",
                                fontWeight: 500,
                                fontSize: '9px'
                            }}
                        >
                            {frenchDatews(getCurrentDatetime())}
                        </p>
                        <p
                            className="text-left"
                            style={{
                                position: 'absolute',
                                marginLeft: "20px",
                                marginTop: "-81px",
                                color: "white",
                                fontWeight: 500,
                                fontSize: '9px'
                            }}
                        >
                            {props.contrat?.numeroPoliceM || props.contrat?.numeroPoliceP}

                        </p>
                        <div style={{
                            position: 'absolute',
                            marginTop: "-79px",
                            fontSize: "9px",
                            textAlign: 'center',
                            width: '82px',
                            height: '19px',
                            alignItems: 'center',
                            marginLeft: '170px',
                            justifyContent: 'center'
                        }}
                        >
                            <p
                                style={{position: 'relative', marginTop: '2px'}}>
                                <b>CIMA {" "} {props?.couleur}   </b>
                            </p>
                        </div>
                        <div style={{
                            position: 'absolute',
                            marginLeft: "19px",
                            marginTop: "-36px",
                            textAlign: 'center',
                            width: '234px',
                            height: '27px',
                            display: 'flex',
                            justifyContent: 'center'
                        }}>

                            <p
                                className="text-left"
                                style={{
                                    fontSize: "14px",
                                    position: 'relative',
                                    fontFamily: 'Poppins',
                                    fontWeight: 'normal',
                                    marginTop: '3px'
                                }}
                            >
                                <b>{props?.engin.numeroAttestationDigitale}</b>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
});
AttestationDigitale.propTypes = {
    contrat: PropTypes.object.isRequired,
    engin: PropTypes.object.isRequired,
}

export default AttestationDigitale